module.exports = __webpack_public_path__ + "static/img/activity-end-icon.bf09cfe8.png";